interface StepCounterProps {
  current: number;
  total: number;
  label: string;
}

export function StepCounter({ current, total, label }: StepCounterProps) {
  return (
    <div className="space-y-1">
      <p className="typo-label text-[color:var(--color-text-md)]">
        Step {current} of {total}
      </p>
      <h2 className="typo-heading text-[color:var(--color-text-hi)]">
        {label}
      </h2>
    </div>
  );
}
